export default "__VITE_ASSET__C2Jw92r7__"